module.exports = __webpack_public_path__ + "img/logo-cs.fb86fd24.svg";